const DEFAULT_VOLUME_SLIDER_RANGE_DB = 37.5

export const getVolumeSliderRangeDb = () => {
	// Range in dB for volume sliders from 0-100%. Earlier testing compared 30,
	// 37.5, and 45 dB ranges; 37.5 dB is the current preferred balance.
	const search = typeof location === 'undefined' ? '' : location.search
	const query = new URLSearchParams(search)
	return Number(query.get('dbRangeVolumeEffect') ?? DEFAULT_VOLUME_SLIDER_RANGE_DB)
}

export const volumeToGain = (volume: number) => {
	const volumeSliderRange = getVolumeSliderRangeDb()
	const dbfs = -volumeSliderRange + (volume * volumeSliderRange)
	if (dbfs == -volumeSliderRange) {
		return 0
	}
	return Math.pow(10, dbfs / 20)
}

export const gainToVolume = (gain: number) => {
	const volumeSliderRange = getVolumeSliderRangeDb()
	const dbfs = 20 * Math.log10(gain)
	return 1 - (dbfs / -volumeSliderRange)
}
